// import from 'bootstrap'
import {
  Modal,
  Offcanvas,
  Tab,
  Popover,
  Dropdown,
  Toast,
  Tooltip,
  Collapse,
  ScrollSpy,
  Button,
  Alert
} from 'bootstrap'

// import custom SCSS
import './scss/main.scss';

// Handle Bootstrap 4 data-dismiss attribute for Bootstrap 5 compatibility
document.addEventListener('DOMContentLoaded', function() {
  // Convert Bootstrap 4 data-dismiss to Bootstrap 5 data-bs-dismiss
  const closeButtons = document.querySelectorAll('[data-dismiss="alert"]');
  closeButtons.forEach(button => {
    button.setAttribute('data-bs-dismiss', 'alert');
    button.removeAttribute('data-dismiss');
    
    // Initialize Bootstrap 5 Alert if not already initialized
    const alertElement = button.closest('.alert');
    if (alertElement && !alertElement.hasAttribute('data-bs-alert-initialized')) {
      new Alert(alertElement);
      alertElement.setAttribute('data-bs-alert-initialized', 'true');
    }
  });
});
